<script lang="ts" setup>
import '@unocss/reset/tailwind.css'

import { onMounted, ref } from 'vue'
import { useHead } from '@vueuse/head'
import { $log } from './helpers'
import { event } from '@/event'
import BasicToast from '@/components/BasicToast.vue'
import BasicLoading from '@/components/BasicLoading.vue'

const testSdkScript = '//p4-ad.adkwai.com/udata/pkg/ks-ad-common-cdn/linyifan/third-sdk/neoAdVideoForThirdParty.js'
const productionSdkScript = '//static.yximgs.com/udata/pkg/ks-ad-common-cdn/ad/dsp/third-sdk/novel/neoAdVideoForThirdParty.js'
useHead({
  script: [
    { src: import.meta.env.MODE === 'production' ? productionSdkScript : testSdkScript },
  ],
})

const loading = ref(true)
onMounted(async () => {
  $log('App', '#onMounted')

  loading.value = false

  // Global tick event
  const interval = 1000
  setInterval(() => {
    event.emit('app:tick', interval)
  }, interval)
})
</script>

<template>
  <div id="app">
    <div v-if="loading">
      <div class="pt-20vh flex justify-center">
        <BasicSpinner class="mx-auto" />
      </div>
    </div>

    <template v-else>
      <RouterView />

      <BasicLoading />
      <BasicToast class="z-1001" />
    </template>

    <portal-target name="root" />
  </div>
</template>

<style>
html, body {
  height: 100%;
}
body {
  font-family: -apple-system, BlinkMacSystemFont, SF UI Text, Helvetica Neue, PingFang SC, Hiragino Sans GB, Microsoft YaHei UI, Microsoft YaHei, Arial, sans-serif;
  touch-action: pan-y;
  font-size: 16px;
  max-width: var(--var-max-body-width, 750px);
  margin: 0 auto;
  background-color: white;
}
#app {
  height: 100vh;
  margin: 0 auto;
  background: #F4F5F7;
  position: relative;
}

/** Some global transition  */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/** Some reset css */
p {
  margin: 0;
  overflow-wrap: anywhere;
}
div, input, textarea, button, select, a {
  -webkit-tap-highlight-color: transparent!important;
}
input:focus {
  outline: 0;
}
</style>
